// @flow
import { Record } from "immutable"

const Balance = Record({
  amount: 0,
  currency: "",
})

export default Balance
